import React, { useEffect, useMemo, useState } from 'react'

import NftList from '../Staking/components/NftList'

export const NFT_LIST_PAGE_SIZE = 10

const tokenIdOf = (item) => String(typeof item === 'object' ? item.id : item)

export default function NftPagedList({
    nfts = [],
    metadataById = {},
    selectedTokenId,
    focusTokenId,
    onSelect,
    onVisibleTokenIds,
    pageSize = NFT_LIST_PAGE_SIZE,
    label = 'NFT',
    resetKey = '',
    t = (key) => key,
}) {
    const [page, setPage] = useState(1)
    const totalPages = Math.max(1, Math.ceil(nfts.length / pageSize))
    const tokenIds = useMemo(() => nfts.map(tokenIdOf), [nfts])
    const safePage = Math.min(page, totalPages)
    const start = (safePage - 1) * pageSize
    const visibleNfts = useMemo(() => nfts.slice(start, start + pageSize), [nfts, pageSize, start])
    const visibleTokenIds = useMemo(() => visibleNfts.map(tokenIdOf), [visibleNfts])

    useEffect(() => {
        setPage(1)
    }, [resetKey])

    useEffect(() => {
        if (page > totalPages) setPage(totalPages)
    }, [page, totalPages])

    useEffect(() => {
        if (!focusTokenId) return
        const focusIndex = tokenIds.indexOf(String(focusTokenId))
        if (focusIndex >= 0) setPage(Math.floor(focusIndex / pageSize) + 1)
    }, [focusTokenId, pageSize, tokenIds])

    useEffect(() => {
        if (!onVisibleTokenIds || visibleTokenIds.length === 0) return
        const missingTokenIds = visibleTokenIds.filter((tokenId) => !metadataById[tokenId])
        if (missingTokenIds.length > 0) onVisibleTokenIds(missingTokenIds)
    }, [metadataById, onVisibleTokenIds, visibleTokenIds])

    return <div className="nft-paged-list">
        <NftList
            nfts={visibleNfts}
            metadataById={metadataById}
            selectedTokenId={selectedTokenId}
            onSelect={onSelect}
            t={t}
        />
        {totalPages > 1 && <nav className="nft-paged-list__pagination" aria-label={`${label} ${t('分页')}`}>
            <button
                type="button"
                className="console-icon-button"
                aria-label={`${t('上一页')} ${label}`}
                title={t('上一页')}
                disabled={safePage <= 1}
                onClick={() => setPage((current) => Math.max(1, current - 1))}
            >
                <i className="fa fa-chevron-left" />
            </button>
            <span>{safePage} / {totalPages}</span>
            <button
                type="button"
                className="console-icon-button"
                aria-label={`${t('下一页')} ${label}`}
                title={t('下一页')}
                disabled={safePage >= totalPages}
                onClick={() => setPage((current) => Math.min(totalPages, current + 1))}
            >
                <i className="fa fa-chevron-right" />
            </button>
        </nav>}
    </div>
}
